import {ReactElement} from "react";
import {Link} from "react-router-dom";

export const ClimateBanner = (): ReactElement => {
    return <div className="fs-7 lh-1 p-1 text-muted">
        <img alt="Climate Banner" src="/assets/img/Stripe Climate Badge.svg" width="24" height="24" className="me-2" />
        <span className="fw-bold">5% of all purchases</span> contribute to removing CO₂ from the atmosphere. <Link className="text-muted" to="https://climate.stripe.com/JRDDb6" target="_blank">Learn more.</Link>
    </div>;
}